var map = {
	"./mobile/guestType1Bg.png": 1119,
	"./mobileBlack/guestType1Bg.png": 167,
	"./pc/guestType1Bg.png": 3259,
	"./pcBlack/guestType1Bg.png": 7227
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3511;